import FormControl from "common/components/FormControl/FormControl";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CrudForm from "common/components/Crud/CrudForm";
import type { FAQ } from "types";

type Props = {
  onSubmit: (values: any) => any;
  onCancel?: () => void;
  item?: FAQ;
};

function FAQForm({ onSubmit, onCancel, item }: Props) {
  const { t } = useTranslation();

  const initialValues = useMemo(
    () =>
      item?.id
        ? {
            ...item,
          }
        : {},
    [item]
  );

  return (
    <CrudForm
      onSubmit={onSubmit}
      onCancel={onCancel}
      initialValues={initialValues}
      headerIcon="QuestionMarkCircleIcon"
      i18nNamespace="faqs"
      render={() => (
        <div className="white-box flex flex-col gap-2">
          <FormControl name="question" title={t("faqs.question")} required />
          <FormControl
            name="answer"
            title={t("faqs.answer")}
            type="textarea"
            required
          />
        </div>
      )}
    />
  );
}

export default FAQForm;
